export const PRETEST_TYPES = Object.freeze({
  ALWAYS: "ALWAYS",
  SOMETIMES: "SOMETIMES",
  NEVER: "NEVER"
});
